import React, {Component} from 'react';
import {
    withGoogleMap,
    GoogleMap,
    Marker,
    TrafficLayer,
} from "react-google-maps";
import { connect } from 'react-redux';
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import MapInfoBox from './mapInfoBox';

class Maps extends Component{

    state={
        infoBoxData : null
    }

    onMarkerClick = (markerData)=>{
        this.setState({ infoBoxData : markerData })
    }

    onInfoBoxCloseClick = ()=>{
        this.setState({ infoBoxData : null })
    }

    render(){

        let maps = window.google.maps;

        // console.log(this.props.viewCampaignItem);

        let {sites} = this.props.viewCampaignItem;

        const show_info_box = this.state.infoBoxData ? true : false;

        let info_box_latitude, info_box_longitude;
        if(show_info_box){

            const {photos, latitude, longitude} = this.state.infoBoxData;

            info_box_latitude = photos.length > 0 ? photos[photos.length -1 ].latitude : latitude;
            info_box_longitude = photos.length > 0 ? photos[photos.length -1 ].longitude : longitude;    
        }
        
        return <GoogleMap
            defaultZoom={6}
            center={this.props.center}
        >

        {show_info_box && <InfoBox 
                position={new maps.LatLng(parseFloat(info_box_latitude), parseFloat(info_box_longitude))}
                options={{enableEventPropagation : true}}
                onCloseClick={this.onInfoBoxCloseClick.bind(this)}
                >
            <MapInfoBox infoBoxData={this.state.infoBoxData}/>
        </InfoBox> }

        <TrafficLayer autoUpdate />

        {/* cluster for sites */}
        <MarkerClusterer minimumClusterSize={10} averageCenter>
            {sites && sites.map((item, index) => {
                let position = { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) };
                return (
                    <Marker key={index}
                        position={position}
                        title={item.site_code}
                        onClick={this.onMarkerClick.bind(this, item)}
                        icon={{ url: "http://locaudit-clients.s3-website-ap-southeast-1.amazonaws.com/images/new_2.png" }} />
                )
            })}
        </MarkerClusterer>

    </GoogleMap>
    }
}

const mapStateToProps = (state)=>{
    return {

    }
}

export default connect(mapStateToProps, {  })(withGoogleMap(Maps));


// WEBPACK FOOTER //
// ./src/v3/components/campaign/maps.js